import React, { useState, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { ToDateTimeText, ToDateFullMonthText } from "../../utils/date";
//Material
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
//Component
import { Modal } from "../../stories/modal";
import FormInput from "../../stories/hook-controls/input";
import { ReactTable } from "../../stories/react-table";
import * as alertDialog from "../../utils/alert";
//Function
import { getHistoryColumns } from "./columns/job-schedule";
import { setDataToFormHookV2, isEmptyStr } from "../../utils/common-function";
import { formatDateTime } from "../../utils/common-function"
import { TextField, Divider } from "@material-ui/core";
import * as api from "./api";
import * as common from "./../../utils/common-function";
import { BaseContainer } from "../../stories/base-container";
import { BoxTemplate1 } from "../../stories/Box";
import { API_URL } from "../../utils/api-utils";
import BootstrapTable from 'react-bootstrap-table-next';

const useStyles = makeStyles((theme) => ({

    textLabel: {
        color: '#000'
    },

}));


function ViewHistory(props) {
    const classes = useStyles();
    const { open } = props;
    const { JobGUID, ...otherprops } = props;

    const method = useForm();
    const { register, getValues } = method;
    const { setValue, setError, clearErrors, errors, control } = method;
    const [JobHistory, setJobHistory] = useState([]);

    useEffect(() => {
        if (!open) return;
        if (typeof JobGUID === "undefined") return;

        fetch(JobGUID);

    }, [JobGUID, setValue, open]);

    const fetch = async (pJobGUID) => {
        let param = { JOB_GUID: pJobGUID };
        let res = await api.GetListJobScheduleHistory(param);
        setJobHistory(res);

    };
    const onDownloadFile = async (pID) => {
        let param = { "EXEC_NO": pID };
        let res = await api.DownloadFile(param);
        //console.log(res);
        if (res?.FileName) {
            window.open(`${API_URL.Loader}/Export/` + res?.FileName, '_blank');
        }
        else {
            alertDialog.ErrorDialog("Error : File Not Found");
        }
    }
    return (
        <Modal
            {...otherprops}
            hiddenSave={true}
            //title="History Detail"
            maxWidth={false}
        >
            <BoxTemplate1 height="80vh" title="History Detail">
                <Grid item xs={4} container spacing={1}>
                    <Grid item xs={3}>
                        <InputLabel id="simple-select-outlined-label" className={classes.textLabel} >Job Name :</InputLabel>
                    </Grid>
                    <Grid item xs={9}>
                        <InputLabel id="simple-select-outlined-label">{JobHistory?.JOB_INFO?.JOB_NAME ?? ""}</InputLabel>
                    </Grid>
                </Grid>
                <Grid item xs={4} container spacing={1}>
                    <Grid item xs={3}>
                        <InputLabel id="simple-select-outlined-label" className={classes.textLabel} >Schedule Type :</InputLabel>
                    </Grid>
                    <Grid item xs={9}>
                        <InputLabel id="simple-select-outlined-label">{JobHistory?.JOB_INFO?.SCHEDULE_TYPE_NAME ?? ""}</InputLabel>
                    </Grid>
                </Grid>
                <Grid item xs={4} container spacing={1}>
                    <Grid item xs={3}>
                        <InputLabel id="simple-select-outlined-label" className={classes.textLabel} >Schedule Date :</InputLabel>
                    </Grid>
                    <Grid item xs={9}>
                        <InputLabel id="simple-select-outlined-label">{JobHistory?.JOB_INFO?.SCHEDULE_DATE_TEXT.join(',') ?? ""}</InputLabel>
                    </Grid>
                </Grid>
                <Grid item xs={4} container spacing={1}>
                    <Grid item xs={3}>
                        <InputLabel id="simple-select-outlined-label" className={classes.textLabel} >Schedule Time :</InputLabel>
                    </Grid>
                    <Grid item xs={9}>
                        <InputLabel id="simple-select-outlined-label">{JobHistory?.JOB_INFO?.SCHEDULE_TIME_HOUR + ":" + JobHistory?.JOB_INFO?.SCHEDULE_TIME_TIME ?? ""}</InputLabel>
                    </Grid>
                </Grid>
                <Grid item xs={4} container spacing={1}>
                    <Grid item xs={3}>
                        <InputLabel id="simple-select-outlined-label" className={classes.textLabel} >Start Date :</InputLabel>
                    </Grid>
                    <Grid item xs={9}>
                        <InputLabel id="simple-select-outlined-label">{ToDateFullMonthText(JobHistory?.JOB_INFO?.START_DATE) ?? ""}</InputLabel>
                    </Grid>
                </Grid>
                <Grid item xs={4} container spacing={1}>
                    <Grid item xs={3}>
                        <InputLabel id="simple-select-outlined-label" className={classes.textLabel} >End Date :</InputLabel>
                    </Grid>
                    <Grid item xs={9}>
                        <InputLabel id="simple-select-outlined-label">{ToDateFullMonthText(JobHistory?.JOB_INFO?.END_DATE) ?? ""}</InputLabel>
                    </Grid>
                </Grid>
                <br />
                <FormProvider>
                    {JobHistory?.JOB_SCHEDULE_HISTORY?.length > 0 ?
                        (<ReactTable id="table_history"
                            keyField="EXEC_NO"
                            data={JobHistory?.JOB_SCHEDULE_HISTORY}
                            showSearch={false}
                            //clickToSelect
                            //headcomponent={tablecomponent}
                            columns={getHistoryColumns(onDownloadFile)}
                        //selectedRow={[461]}
                        // disableSelectable={DataList?.filter((x => x.SHOW_EXTEND === 0)).map((c) => 
                        //   c.ROW_NUMBER)}
                        />) : <BootstrapTable keyField='EXEC_NO' data={[]} columns={getHistoryColumns(onDownloadFile)} noDataIndication={'No results found'} />}
                </FormProvider>
            </BoxTemplate1>
        </Modal>
    );
}
export default ViewHistory;
